module.exports = __webpack_public_path__ + "static/fonts/AlineaSansBold.a296b26.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/AlineaSansBold.ttf
// module id = 966
// module chunks = 113